import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ num, label, dark = false }) => (
    <div className="flex items-center gap-3 mb-5">
        <span className={`font-mono text-xs tracking-[0.25em] ${dark ? "text-leaf-soft" : "text-leaf"}`}>{num}</span>
        <span className={`h-px w-8 ${dark ? "bg-leaf-soft/50" : "bg-leaf/40"}`} />
        <span className={`font-mono text-xs uppercase tracking-[0.25em] font-semibold ${dark ? "text-white/70" : "text-forest"}`}>
            {label}
        </span>
    </div>
);
